var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useAccountSummary, useRewardsBalance, useRewardsCertificate } from '../const/syfApiQueries';
import { rewardIds } from '../typings/rewardsTypes';
import { useRewardsConfigContext } from '../context/rewardsConfig';
import { getSelectedAccountId } from '../helpers/sessionAccountId';
import experienceData from '../experience';
var rewardsExperience = experienceData;
var useRewards = function () {
    var _a, _b;
    var config = useRewardsConfigContext().config;
    var selectedAccountId = getSelectedAccountId();
    var _c = useAccountSummary(selectedAccountId, config), accountSummary = _c.data, isLoadingAccountSummary = _c.isLoading, isAccountSummaryError = _c.isError;
    var clientId = (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.clientId) !== null && _a !== void 0 ? _a : '';
    var cardType = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.type;
    var rewardsExperienceForClient = (_b = rewardsExperience[clientId]) === null || _b === void 0 ? void 0 : _b[cardType];
    var hasRewardsBalance = Boolean(rewardsExperienceForClient === null || rewardsExperienceForClient === void 0 ? void 0 : rewardsExperienceForClient.rewardsBalance);
    var hasCashRewardsBalance = Boolean(rewardsExperienceForClient === null || rewardsExperienceForClient === void 0 ? void 0 : rewardsExperienceForClient.cashRewardsBalance);
    var hasCertificateHistory = Boolean(rewardsExperienceForClient === null || rewardsExperienceForClient === void 0 ? void 0 : rewardsExperienceForClient.certificateHistory);
    var _d = useRewardsBalance({
        accountId: selectedAccountId,
        config: __assign(__assign({}, config), { clientId: clientId }),
        hasRewardsBalance: hasRewardsBalance
    }), rewardsBalance = _d.data, isLoadingRewardsBalance = _d.isLoading, isErrorRewardsBalance = _d.isError, isRewardsBalanceFetching = _d.isFetching;
    var _e = useRewardsCertificate({
        config: __assign(__assign({}, config), { clientId: clientId }),
        accountId: selectedAccountId,
        hasCertificateHistory: hasCertificateHistory,
        certificateRequestType: 'ALL'
    }), allRewardsCertificate = _e.data, isLoadingAllRewardsCertificate = _e.isLoading, isAllRewardsCertificateError = _e.isError, isCertificatesFetching = _e.isFetching;
    var isLoading = isLoadingAccountSummary ||
        (isLoadingRewardsBalance && isRewardsBalanceFetching) ||
        (isLoadingAllRewardsCertificate && isCertificatesFetching);
    var isError = isAccountSummaryError ||
        isErrorRewardsBalance ||
        isAllRewardsCertificateError;
    var certificates = allRewardsCertificate;
    var rewardDetails = {};
    rewardsBalance === null || rewardsBalance === void 0 ? void 0 : rewardsBalance.rewardDetails.forEach(function (reward) {
        var rewardId = reward.Id;
        if (rewardIds.includes(rewardId)) {
            rewardDetails[rewardId] = reward;
        }
    });
    return {
        accountSummary: accountSummary,
        allRewardsCertificate: allRewardsCertificate,
        cardType: cardType,
        certificates: certificates,
        clientId: clientId,
        hasCashRewardsBalance: hasCashRewardsBalance,
        hasCertificateHistory: hasCertificateHistory,
        isError: isError,
        isLoading: isLoading,
        rewardsBalance: rewardsBalance,
        rewardDetails: rewardDetails,
        rewardsExperience: rewardsExperience
    };
};
export default useRewards;
